// All-projects listing events (analytics sheet → "All Projects Listing Page").
import {AnalyticsEntryPoint} from './events';
import {listingAnalytics} from './listing-page.analytics';

const projects = listingAnalytics(AnalyticsEntryPoint.AllProjectsListing);

export const trackProjectsListingViewItemClick = projects.viewItemClick;
export const trackProjectsListingCardClick = projects.cardClick;
export const trackProjectsListingRegisterInterestClick = projects.registerInterestClick;
